interface ProcessPhaseProps {
  phase: {
    number: string;
    title: string;
    duration: string;
    description: string;
    deliverables: string[];
    clientResponsibilities: string[];
    qualityCheckpoints: string[];
  };
  isActive: boolean;
  onPhaseClick: () => void;
}

const ProcessPhase = ({ phase, isActive, onPhaseClick }: ProcessPhaseProps) => {
  return (
    <div
      onClick={onPhaseClick}
      className={`cursor-pointer transition-all duration-300 ${
        isActive ? 'scale-105' : 'hover:scale-102'
      }`}
    >
      <div
        className={`bg-white rounded-2xl p-6 border-2 transition-all duration-300 ${
          isActive
            ? 'border-[#1B5E4F] shadow-lg'
            : 'border-zinc-200 hover:border-[#1B5E4F]/50'
        }`}
      >
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center space-x-4">
            <div
              className={`w-12 h-12 rounded-full flex items-center justify-center font-headline text-xl font-normal transition-colors duration-300 ${
                isActive
                  ? 'bg-[#1B5E4F] text-white'
                  : 'bg-zinc-100 text-black/50'
              }`}
            >
              {phase.number}
            </div>
            <div>
              <h3 className="font-headline text-xl font-normal text-black mb-1">
                {phase.title}
              </h3>
              <p className="text-sm text-black/60 font-normal">
                Duration: {phase.duration}
              </p>
            </div>
          </div>
        </div>

        <p className="text-black/70 font-normal mb-4 leading-relaxed">
          {phase.description}
        </p>

        {isActive && (
          <div className="space-y-4 mt-6 pt-6 border-t border-zinc-200">
            <div>
              <h4 className="font-medium text-black mb-2 flex items-center">
                <span className="w-2 h-2 bg-[#1B5E4F] rounded-full mr-2"></span>
                Key Deliverables
              </h4>
              <ul className="space-y-2">
                {phase.deliverables.map((item, idx) => (
                  <li
                    key={idx}
                    className="text-sm text-black/70 font-normal pl-4 flex items-start"
                  >
                    <span className="text-[#1B5E4F] mr-2">•</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-medium text-black mb-2 flex items-center">
                <span className="w-2 h-2 bg-amber-500 rounded-full mr-2"></span>
                Your Role
              </h4>
              <ul className="space-y-2">
                {phase.clientResponsibilities.map((item, idx) => (
                  <li
                    key={idx}
                    className="text-sm text-black/70 font-normal pl-4 flex items-start"
                  >
                    <span className="text-amber-500 mr-2">•</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-medium text-black mb-2 flex items-center">
                <span className="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
                Quality Checkpoints
              </h4>
              <ul className="space-y-2">
                {phase.qualityCheckpoints.map((item, idx) => (
                  <li
                    key={idx}
                    className="text-sm text-black/70 font-normal pl-4 flex items-start"
                  >
                    <span className="text-blue-500 mr-2">•</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProcessPhase;